module.exports = __webpack_public_path__ + "img/story16.3.jpg";